import * as downloadFileService from "../services/kyc/download-file-service";

export const downloadFile = async (that, name, fileId) => {
  let data = {
    clientId: that.state.clientId,
    fileName: name,
    fileId: fileId,
  };
  let { response, err } = await downloadFileService.downloadFile(data);
  if (err) {
    that.setState({
      message: "Server failed, file did not get downloaded",
    });
  } else {
    const url = await window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  }
};
